import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { SERVICE_CALLS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/service_calls_actions';

const initialState: any = standardInitialStateGenerator(['serviceCallsCalendarIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
